

















































































































































import Vue from 'vue'

export default Vue.extend({
  props: {
    counselingQuestionsClient: {
      type: Object,
      required: false,
      default: null,
    },
    counselingQuestionsCorrected: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    hasClientAnswers() {
      return this.counselingQuestionsClient !== null
    },
    hasCorrectedAnswers() {
      return this.counselingQuestionsCorrected !== null
    },
  },
})
